import { render } from "./PlatformModules.vue?vue&type=template&id=6745f45e"
import script from "./PlatformModules.vue?vue&type=script&lang=js"
export * from "./PlatformModules.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__